export default "__VITE_ASSET__CW4xt$o4__"